import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';

import { KuposButton, KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import { bindActionCreators } from 'redux';
import { collect } from 'underscore';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { withTranslation } from 'react-i18next';

const ivergramaIcon1 = '/assets/ivergrama/Services/Ivergrama-Website-Services-1.svg';
const ivergramaIcon2 = '/assets/ivergrama/Services/Ivergrama-Website-Services-2.svg';
const ivergramaIcon3 = '/assets/ivergrama/Services/Ivergrama-Website-Services-3.svg';
const ivergramaIcon4 = '/assets/ivergrama/Services/Ivergrama-Website-Services-4.svg';

const busnorteIcon1 = 'assets/norte/Home/correo.svg';
const busnorteIcon2 = 'assets/norte/Home/Contact.svg';

const aeroquintaIcon1 = '/assets/aeroquinta/Home/correo.svg';
const aeroquintaIcon2 = '/assets/aeroquinta/Home/contact.svg';
const aeroquintaIcon3 = '/assets/aeroquinta/Home/aeroquinta-Website-Services-3.svg';
const aeroquintaIcon4 = '/assets/aeroquinta/Home/aeroquinta-Website-Services-4.svg';

const torresIcon1 = '/assets/torres/service/service-one.svg';
const torresIcon2 = '/assets/torres/service/service-five.svg';
const torresIcon3 = '/assets/torres/service/service-four.svg';
const torresIcon4 = '/assets/torres/service/service-two.svg';
const torresIcon5 = '/assets/torres/service/service-three.svg';

const torresIconsAndTexts = [
	{ image: torresIcon1, caption: 'Buses regulares', line: true },
	{ image: torresIcon2, caption: 'Transfer al aeropuerto', line: true },
	{ image: torresIcon3, caption: 'Servicio turístico all day', line: true },
	{ image: torresIcon4, caption: 'Paseo en catamarán', line: true },
	{ image: torresIcon5, caption: 'Servicio de campings' },
];


const ivergramaIconsAndTexts = [
	{ image: ivergramaIcon1, caption: 'Turismo Nacional o Internacional', line: true },
	{ image: ivergramaIcon2, caption: 'Traslado de Personal', line: true },
	{ image: ivergramaIcon3, caption: 'Movilización para Eventos', line: true },
	{ image: ivergramaIcon4, caption: 'Viajes Especiales' },
];

const busnorteIconsAndTexts = [
	{ image: busnorteIcon1, caption: 'Turismo Nacional o Internacional', line: true },
	{ image: busnorteIcon2, caption: 'Turismo Nacional o Internacional', line: true },
	// { image: ivergramaIcon2, caption: 'Traslado de Personal', line: true },
	// { image: ivergramaIcon3, caption: 'Movilización para Eventos', line: true },
	// { image: ivergramaIcon4, caption: 'Viajes Especiales' },
];
const aeroquintaIconsAndTexts = [
	{ image: aeroquintaIcon1, caption: 'Turismo Nacional o Internacional', line: true },
	{ image: aeroquintaIcon2, caption: 'Traslado de Personal', line: true },
	{ image: aeroquintaIcon3, caption: 'Movilización para Eventos', line: true },
	{ image: aeroquintaIcon4, caption: 'Viajes Especiales' },
];


let initialState = {
	name: null,
	nameError: false,
	mobile: null,
	mobileError: false,
	email: null,
	emailError: false,
	message: null,
	messageError: false,
};

const getContactInfo = operator => {
	const ivergramaContactInfo = [
		{
			image: getIcons('contactMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
		{
			image: getIcons('contactAddress', operator),
			caption: operator && operator.address && operator.address,
			line: true,
		},
	];
	const busnorteContactInfo = [
		{
			image: getIcons('busnorteContactMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
		{
			image: getIcons('busnorteContact', operator),
			caption: operator && operator.phone_number && operator.phone_number,
			line: true,
		},
	];
	const aeroquintaContactInfo = [
		{
			image: getIcons('aeroquintaMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
		{
			image: getIcons('aeroquintaContact', operator),
			caption: operator && operator.phone_number && operator.phone_number,
			line: true,
		},
		{
			image: getIcons('Contact', operator),
			caption: operator && operator.phone_number && operator.phone_number,
			line: true,
		},
	];
	const torresContactInfo = [
		{
			image: getIcons('contactMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
		{
			image: getIcons('contactPhone', operator),
			caption: operator && operator.phone_number && operator.phone_number,
			line: true,
		},

	];
	const name = operator && operator.operator_name;
	if (name === 'ivergrama') {
		return ivergramaContactInfo;
	} else if (name === "busnorte") {
		return busnorteContactInfo;
	} else if (name === "aeroquinta") {
		return aeroquintaContactInfo;
	}
	else if (name === 'basetorres') {
		return torresContactInfo;
	} else {
		return [];
	}
};
const getIconsAndTexts = operator => {
	const name = operator && operator.operator_name;
	if (name === 'ivergrama') {
		return ivergramaIconsAndTexts;
	} else if (name === "busnorte") {
		return busnorteIconsAndTexts
	} else if (name === "aeroquinta") {
		return aeroquintaIconsAndTexts
	} else if (name === 'basetorres') {
		return torresIconsAndTexts;
	} else {
		return [];
	}
};
const ThemeThreeContactForm = props => {
	console.log("🚀 ~ ThemeThreeContactForm ~ props:??????", props)
	const operator = CommonService.getLocal('op') || props.home.operator;
	let phoneNumberOne = '';
	let phoneNumberTwo = '';
	const [state, setState] = useState(initialState);
	if (
		(props.operator && props.operator.operator_name === 'ivergrama' || props.operator && props.operator.operator_name === 'busnorte')
	) {
		const temp = props.operator.phone_number.split('/');
		phoneNumberOne = temp[0];
		phoneNumberTwo = temp[1];
	}


	const onChange = (value, type) => {
		if (type == 'mobile') {
			value = CommonService.phoneNumberFormat(value);
			setState({
				...state,
				[type]: value,
				[type + 'Error']: false,
			});
		} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
		}
	};

	const validate = () => {

		let errorCount = 0;
		if (!state.name) {
			setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
			errorCount++;
		} else if (!state.mobile) {
			setState({
				...state,
				mobileError: true,
				mobileErrorMessage: 'Ingresa tu número de teléfono',
			});
			errorCount++;
		} else if (!state.email) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		}
		// else if (!state.message) {
		//  setState({
		//   ...state,
		//   messageError: true,
		//   messageErrorMessage: 'Inserta tu comentario',
		//  });
		//  errorCount++;
		// }

		if (errorCount > 0) {

			return false;
		} else {

			return true;
		}
	};

	const onSubmit = () => {

		if (!validate()) {

			return;
		}
		// Ensure form submission only for 'tarapaca' or 'santamaria'
		if (props.home.operator && props.home.operator.operator_name === 'ivergrama' || props.home.operator && props.home.operator.operator_name === 'busnorte' || props.home.operator && props.home.operator.operator_name === 'aeroquinta' || props.home.operator && props.home.operator.operator_name === 'basetorres') {

			// Operators that require the last_name field
			const operatorsRequiringLastName = []; // Add the operators' names in Array that require last_name

			let data = {
				name: state.name,
				email: state.email,
				phone_number: state.mobile,
				comments: state.message,
				operator_id: props.home.operator.operator_id,
				operator_name: props.home.operator.operator_name,
			};

			// Add last_name to data if the current operator requires it
			if (operatorsRequiringLastName.includes(props.home.operator.operator_name) && state.last_name) {
				data.last_name = state.last_name;
			}

			props.actions.apiCall({

				url: AppData.BASE_URL + 'api/opsite_contact_info',
				method: 'POST',
				data,
			})
				.then(res => onContactInfoResponse(res), err => onContactInfoResponse(err));
		}
		if (props.home.operator && props.home.operator.operator_name === 'busnorte' || props.home.operator && props.home.operator.operator_name === 'arzola') {

			// Operators that require the last_name field
			const operatorsRequiringLastName = []; // Add the operators' names in Array that require last_name

			let data = {
				name: state.name,
				email: state.email,
				phone_number: state.mobile,
				comments: state.message,
				operator_id: props.home.operator.operator_id,
				operator_name: props.home.operator.operator_name,
			};

			// Add last_name to data if the current operator requires it
			if (operatorsRequiringLastName.includes(props.home.operator.operator_name) && state.last_name) {
				data.last_name = state.last_name;
			}

			props.actions.apiCall({

				url: AppData.BASE_URL + 'api/opsite_contact_info',
				method: 'POST',
				data,
			})
				.then(res => onContactInfoResponse(res), err => onContactInfoResponse(err));
		}
	};

	const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
			setState({
				...state,
				showModal: true,
				responseMessage: res.data.message,
				status: res.data.status,
			});
		}
	};
	return (
		<div className="themes-theme-three-contact-form new-container">

			{operator && operator.operator_name === "basetorres" ?
				(<div className="form-section ivergama-form torresform">
					<style>
						.btn{'{'}
						background:
						{operator &&
							operator.color_codes &&
							operator.color_codes.button_color &&
							operator.color_codes.button_color}
						{'}'}
						.btn:hover{'{'}
						background:
						{operator &&
							operator.color_codes &&
							operator.color_codes.secondary_color &&
							operator.color_codes.secondary_color}
						{'}'}
					</style>
					<h2>Contáctanos</h2>

					<div className="contact-input-item">
						<div className="contact-input-label less-bold-text ">Nombre</div>
						<KuposInput
							type="text"
							onChange={value => onChange(value, 'name')}
							value={state.name}
							error={state.nameError}
							errorMessage={state.nameErrorMessage}
							placeholder="Ej. Pedro"
						/>
					</div>

					<div className="contact-input-item ">
						<div className="contact-input-label less-bold-text ">Teléfono</div>

						<KuposInput
							type="number"
							onChange={value => onChange(value, 'mobile')}
							value={state.mobile}
							error={state.mobileError}
							errorMessage={state.mobileErrorMessage}
							placeholder="+56 9 0000 0000"
						/>
					</div>

					<div className="contact-input-item">
						<div className="contact-input-label less-bold-text ">Email</div>
						<KuposInput
							type="email"
							onChange={value => onChange(value, 'email')}
							value={state.email}
							error={state.emailError}
							errorMessage={state.emailErrorMessage}
							placeholder="ejemplo@gmail.com"
						/>
					</div>

					<div className="contact-input-item">
						<div className="contact-input-label less-bold-text ">Comentario</div>

						<textarea
							className="text-area "
							rows={4}
							onChange={event => onChange(event.target.value, 'message')}
							value={state.message}
							placeholder="Opcional"
						/>
						{state.messageError ? (
							<span className="error font8" style={{ color: 'red' }}>
								{state.messageErrorMessage}
							</span>
						) : null}
					</div>

					<div className="contact-input-item ">
						{(operator && operator.operator_name === 'ivergrama') || (operator && operator.operator_name === 'basetorres') ? (
							<KuposButton
								operator={props.operator}
								className="button-padding submit-btn"
								onClick={() => {
									onSubmit();
								}}
							>
								<img src={getIcons('sendBtn', operator)} alt="" class="send-btn" />
								ENVIAR
							</KuposButton>
						) : (

							<KuposButton
								operator={props.operator}
								className={operator && operator.operator_name === 'aeroquinta' || operator && operator.operator_name === 'basetorres' ? "button-padding submit-btn" : 'button-padding submit-btn green-btn'}
								onClick={() => {
									onSubmit();

								}}
							>
								{operator && operator.operator_name === "aeroquinta" || operator && operator.operator_name === "arzola" ? null : <img src="assets/norte/Home/enviar.svg" class="send-btn" />}
								ENVIAR
							</KuposButton>
						)}
						<KuposErrorSuccessModal
							success={state.status == 200 ? true : false}
							showModal={state.showModal}
							onButtonClick={() => {
								setState({ showModal: false });
								window.location.reload();
							}}
							bodyText={state.responseMessage}
						/>
					</div>
				</div>) : (<div className="form-section ivergama-form">
					<style>
						.btn{'{'}
						background:
						{operator &&
							operator.color_codes &&
							operator.color_codes.button_color &&
							operator.color_codes.button_color}
						{'}'}
						.btn:hover{'{'}
						background:
						{operator &&
							operator.color_codes &&
							operator.color_codes.secondary_color &&
							operator.color_codes.secondary_color}
						{'}'}
					</style>
					<h2 className="bold-text">Contáctanos</h2>

					<div className="contact-input-item">
						<div className="contact-input-label less-bold-text ">Nombre</div>
						<KuposInput
							type="text"
							onChange={value => onChange(value, 'name')}
							value={state.name}
							error={state.nameError}
							errorMessage={state.nameErrorMessage}
							placeholder="Ej. Pedro"
						/>
					</div>

					<div className="contact-input-item ">
						<div className="contact-input-label less-bold-text ">Teléfono</div>

						<KuposInput
							type="number"
							onChange={value => onChange(value, 'mobile')}
							value={state.mobile}
							error={state.mobileError}
							errorMessage={state.mobileErrorMessage}
							placeholder="+56 9 0000 0000"
						/>
					</div>

					<div className="contact-input-item">
						<div className="contact-input-label less-bold-text ">Email</div>
						<KuposInput
							type="email"
							onChange={value => onChange(value, 'email')}
							value={state.email}
							error={state.emailError}
							errorMessage={state.emailErrorMessage}
							placeholder="ejemplo@gmail.com"
						/>
					</div>

					<div className="contact-input-item">
						<div className="contact-input-label less-bold-text ">Comentario</div>

						<textarea
							className="text-area "
							rows={4}
							onChange={event => onChange(event.target.value, 'message')}
							value={state.message}
							placeholder="opcional"
						/>
						{state.messageError ? (
							<span className="error font8" style={{ color: 'red' }}>
								{state.messageErrorMessage}
							</span>
						) : null}
					</div>

					<div className="contact-input-item ">
						{(operator && operator.operator_name === 'ivergrama') || (operator && operator.operator_name === 'basetorres') ? (
							<KuposButton
								operator={props.operator}
								className="button-padding submit-btn"
								onClick={() => {
									onSubmit();
								}}
							>
								<img src={getIcons('sendBtn', operator)} alt="" class="send-btn" />
								ENVIAR
							</KuposButton>
						) : (

							<KuposButton
								operator={props.operator}
								className={operator && operator.operator_name === 'aeroquinta' || operator && operator.operator_name === 'basetorres' ? "button-padding submit-btn" : 'button-padding submit-btn green-btn'}
								onClick={() => {
									onSubmit();

								}}
							>
								{operator && operator.operator_name === "aeroquinta" || operator && operator.operator_name === "arzola" ? null : <img src="assets/norte/Home/enviar.svg" class="send-btn" />}
								ENVIAR
							</KuposButton>
						)}
						<KuposErrorSuccessModal
							success={state.status == 200 ? true : false}
							showModal={state.showModal}
							onButtonClick={() => {
								setState({ showModal: false });
								window.location.reload();
							}}
							bodyText={state.responseMessage}
						/>
					</div>
				</div>)}
			{/* {props.homeImage ? (
    <div className="home-image">
     <img src={getIcons('contactFormImg', operator)} alt="" />
    </div>
   ) : null} */}
			{operator.operator_name === 'busnorte' && !props.contactForm ? (
				<a href="https://www.busnortecargo.cl/" target="_blank" rel="noopener noreferrer" style={{ width: "49%" }}>
					<img src={getIcons('contactFormImg', operator)} alt="" />
				</a>
			) : operator.operator_name === 'aeroquinta' && !props.contactForm ? (
				<a href="https://www.viptravelchile.com/" target="_blank" rel="noopener noreferrer" style={{ width: "49%" }}>
					<img src={getIcons('contactFormImg', operator)} alt="" height={"100%"} />
				</a>
			) : (
				props.homeImage ? (
					<div className="home-image">
						<img src={getIcons('contactFormImg', operator)} alt="" />
					</div>
				) : null
			)}

			{props.service ? <ServiceIcons operator={operator} /> : null}

			{props.contactForm ? <ContactInfo operator={operator} /> : null}

		</div>

	);
};

const ContactInfo = ({ operator }) => {
	const renderIconsAndText = (item, key, length) => (
		<React.Fragment>
			<div className="item">
				<div>
					<img src={item.image} alt="Giras de estudio" className="contact_icon" />
				</div>
				<div className="caption ">{item.caption}</div>
			</div>
			{item.line ? (
				<hr
					style={{
						borderColor: operator && operator.color_codes && operator.color_codes.secondary_color,
					}}
				/>
			) : null}
		</React.Fragment>
	);

	return (
		<React.Fragment>
			{operator && operator.operator_name !== 'aeroquinta' ? (
				<div className="contactus">
					{getContactInfo(operator).map((item, key) => (
						renderIconsAndText(item, key, getIconsAndTexts().length)
					))}

					<style>
						{`.contactus .fb {
							background-image: url(${getIcons('fb', operator)});
						}
						.contactus .fb:hover {
							background-image: url(${getIcons('fbHover', operator)});
						}
						.contactus .twitter {
							background-image: url(${getIcons('twitter', operator)});
						}
						.contactus .twitter:hover {
							background-image: url(${getIcons('twitterHover', operator)});
						}
						.contactus .instagram {
							background-image: url(${getIcons('instagram', operator)});
						}
						.contactus .instagram:hover {
							background-image: url(${getIcons('instagramHover', operator)});
						}`}
					</style>

					<div className="contact-links">
						{operator.operator_name === "busnorte" ? (
							<React.Fragment>
								<a href="https://www.facebook.com/busnorteoficial" target="_blank" rel="noopener noreferrer">
									<span className="fb social"></span>
								</a>
								<a href="https://www.instagram.com/busnorteoficial/" target="_blank" rel="noopener noreferrer">
									<span className="twitter social"></span>
								</a>
							</React.Fragment>
						) : operator.operator_name === "ivergrama" ? (
							<React.Fragment>
								<a href="https://www.facebook.com/Buses-Ivergrama-931335030348861/" target="_blank" rel="noopener noreferrer">
									<span className="fb social"></span>
								</a>
								<a href="https://twitter.com/busesiver" target="_blank" rel="noopener noreferrer">
									<span className="twitter social"></span>
								</a>
							</React.Fragment>
						) : operator.operator_name === "aeroquinta" ? (
							<React.Fragment>
								<a href='https://www.facebook.com/people/Buses-Aeroquinta/61562486544013/?mibextid=ZbWKwL' target='_blank' rel="noopener noreferrer">
									<span className="fb social"></span>
								</a>
								<a href='https://www.instagram.com/buses.aeroquinta/?igsh=YXZzdTI1MHpqd3pi' target='_blank' rel="noopener noreferrer">
									<span className="instagram social"></span>
								</a>
							</React.Fragment>
						) : operator && operator.operator_name === "basetorres" ? <React.Fragment>
							<p className='font9 bold-text'><b>Síguenos en redes sociales</b></p>
							<div className='mt-20'>
								<a href='https://www.facebook.com/people/Buses-Base-Torres/100064765328472/?_rdr' target='_blank'> <span class="fb social"></span></a>
								<a href='https://www.instagram.com/busesbasetorres/?hl=es-la' target='_blank'> <span class="instagram social"></span> </a> 			</div></React.Fragment> : null}
					</div>
				</div>
			) : (
				<div className="contactus">
					<div className="item">
						<div>
							<img src="/assets/aeroquinta/Contact/correo.png" alt="Giras de estudio" className="contact_icon" />
						</div>
						<h2 className="caption ">{operator.email}</h2>

					</div>
					<hr
						style={{
							borderColor: operator && operator.color_codes && operator.color_codes.secondary_color,
						}}
					/>
					<div className="item">
						<div>
							<img src="/assets/aeroquinta/Contact/contact.svg" alt="Giras de estudio" className="contact_icon" />
						</div>
					</div>
					<div style={{ display: 'flex', flexDirection: 'column',marginLeft: '30px',marginTop:-30 }}>
                        <div className="caption bold-text">Atención al cliente</div>
						<div className='caption my-3'>		<p>Horarios: 9:00 a 18:00</p>
						<p>Teléfono: +56 9 9820 2767</p></div>

						<div className="caption bold-text">Coordinación de pasajeros</div>

					<div className='caption my-3 '>	<p>Horarios: Disponible 30 minutos antes de cada servicio</p>
						<p>Teléfono: +56 9 9211 6774</p></div>

					</div>
					<hr
						style={{
							borderColor: operator && operator.color_codes && operator.color_codes.secondary_color,
						}}
					/>
					<div className='my-3'>
						<a href='https://www.facebook.com/people/Buses-Aeroquinta/61562486544013/?mibextid=ZbWKwL' target='_blank' rel="noopener noreferrer">
							<span className="fb social"></span>
						</a>
						<a href='https://www.instagram.com/buses.aeroquinta/?igsh=YXZzdTI1MHpqd3pi' target='_blank' rel="noopener noreferrer">
							<span className="instagram social"></span>
						</a>
					</div>
				</div>
			)}
		</React.Fragment>
	);
};


const ServiceIcons = ({ operator }) => {
	const renderIconsAndText = (item, key, length) => {
		return (
			<React.Fragment>
				<div className="item">
					<div>
						<img src={item.image} alt="Giras de estudio" className="icon" />
					</div>
					<div className="caption ">{item.caption}</div>
				</div>
				{item.line ? (
					<hr
						style={{
							borderColor: operator && operator.color_codes && operator.color_codes.secondary_color,
						}}
					/>
				) : null}
			</React.Fragment>
		);
	};

	return (
		<div className="services">
			{getIconsAndTexts(operator).map((item, key) => {
				return renderIconsAndText(item, key, getIconsAndTexts().length);
			})}
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...homeActions, ...commonActions }, dispatch),
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation('common')(ThemeThreeContactForm));
// function mapStateToProps(state) {
//   return {
//     themes: state.themes,
//     home: state.home,
//   };
// }

// /* istanbul ignore next */
// // function mapDispatchToProps(dispatch) {
// //   return {
// //     actions: bindActionCreators({ ...actions }, dispatch)
// //   };
// // }

// export default connect(mapStateToProps, {})(ThemeThreeContactForm);




// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/common/ThemeThreeContactForm.js